import { render } from "./PrincingPlans.vue?vue&type=template&id=52eaf032&scoped=true&lang=pug"
import script from "./PrincingPlans.vue?vue&type=script&setup=true&lang=js"
export * from "./PrincingPlans.vue?vue&type=script&setup=true&lang=js"

import "./PrincingPlans.vue?vue&type=style&index=0&id=52eaf032&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52eaf032"]])

export default __exports__